import * as React from "react";

import Typography from "@mui/material/Typography";

interface StatsTextProps {
    globalBallsThrown: number;
}

export default function StatsText({
    globalBallsThrown,
}: StatsTextProps): React.JSX.Element {
    const formattedCount = Intl.NumberFormat().format(globalBallsThrown);

    return (
        <Typography
            variant="body2"
            sx={{
                textAlign: "center",
                color: "white",
                fontSize: "0.8rem",
                margin: "20px 0 15px 0",
                fontWeight: 600,
            }}
        >
            {`Volley trainers have thrown ${formattedCount} balls`}
        </Typography>
    );
}
